/**
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: "/api/v1",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {
    server1: "/api/v1"
};
export type User = {
    id: number;
    email: string;
};
export type Error = {
    error: string;
};
/**
 * Returns the authenticated user
 */
export function userInfo(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 500;
        data: Error;
    }>("/me", {
        ...opts
    });
}
